// extracted by mini-css-extract-plugin
module.exports = {"container":"JudgingCompetitionsView_container__1trgp","containerBox":"JudgingCompetitionsView_containerBox__1ixfO"};